import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class DealerNotificationsClient {
  static baseUrl = BASE_URL;

  static getDealerNotifications(user, currentPage = 0) {
    const dealerIds = user?.getCommonIdsWithSDLR?.() || "";

    if (!dealerIds || dealerIds.trim() === "") {
      console.warn(
        "DealerNotificationsClient: No dealer IDs available, skipping API call"
      );
      return Promise.resolve({
        notifications: [],
        totalPages: 0,
        currentPage: 0,
      });
    }

    const url = `${this.baseUrl}/dealer/notifications?dealerCommonIds=${dealerIds}&currentPage=${currentPage}`;

    return axios
      .get(url, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        console.error("Error fetching dealer notifications:", error);
        return Promise.reject(error);
      });
  }

  static markNotificationStatusRead(user, id) {
    const url = `${this.baseUrl}/dealer/notifications/${id}`;

    return axios
      .post(url, "", getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static deleteNotification(user, id) {
    const url = `${this.baseUrl}/dealer/notifications/${id}`;

    return axios
      .delete(url, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
